import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetDetailOvertimeFailed,
  actGetDetailOvertimeSuccess,
  MASTER_GET_DETAIL_OVERTIME,
} from '../../actions/overtime'
import { apiGetDetailOvertime } from '../../apis/overtime'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDetail(action) {
  try {
    const response = yield call(apiGetDetailOvertime, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actGetDetailOvertimeSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetDetailOvertimeFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetDetail() {
  yield takeLatest(MASTER_GET_DETAIL_OVERTIME, doGetDetail)
}
